import React, { useState, useEffect } from 'react';
import TaxReturn from './TaxReturn';
import { useTranslation } from 'react-i18next';
import * as api from '../../services/apis';
import { useKeycloak } from '../../hooks/useKeycloak';

const TaxReturnContainer = ({ ...restProps }) => {
  const [returns, setReturns] = useState([]);
  const [loading, setLoading] = useState(true);

  const { userInfo } = useKeycloak();

  const { t } = useTranslation();

  const getTaxReturnList = (taxNumber) => {
    api
      .getTaxReturnsList(taxNumber)
      .then((resp) => {
        setReturns(resp.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log({ err });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (userInfo) {
      getTaxReturnList(userInfo.tax_number);
    }
  }, [userInfo]);

  return <TaxReturn {...restProps} t={t} loading={loading} returns={returns} />;
};

export default React.memo(TaxReturnContainer);
